import { render } from "./ScheduleFormStepEmployees.vue?vue&type=template&id=515ca1f6"
import script from "./ScheduleFormStepEmployees.vue?vue&type=script&lang=ts"
export * from "./ScheduleFormStepEmployees.vue?vue&type=script&lang=ts"
script.render = render

export default script